import { useState } from 'react';
import { submitNps } from '../lib/npsClient';

/**
 * Formulaire de satisfaction (NPS) côté client (parité C4).
 * Affiché après une commande. Note 0-10 + commentaire facultatif → nps_responses.
 */
export default function NpsForm({ tenantId, email }: { tenantId: string; email?: string }) {
  const [score, setScore] = useState<number | null>(null);
  const [comment, setComment] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  if (sent) {
    return (
      <div className="rounded-xl bg-slate-50 p-4 text-center text-sm">
        🙏 Merci pour votre retour, il nous aide à nous améliorer !
      </div>
    );
  }

  const send = async () => {
    if (score === null) return;
    setBusy(true);
    const ok = await submitNps({ tenantId, score, comment, email });
    setBusy(false);
    if (ok) setSent(true);
  };

  return (
    <div className="flex flex-col gap-3 rounded-xl border border-slate-200 p-4">
      <p className="text-sm font-semibold">
        Recommanderiez-vous ce restaurant ? <span className="opacity-60">(0 = jamais, 10 = absolument)</span>
      </p>
      <div className="grid grid-cols-11 gap-1">
        {Array.from({ length: 11 }).map((_, n) => (
          <button
            key={n}
            onClick={() => setScore(n)}
            className="aspect-square rounded-md border text-sm font-semibold transition"
            style={
              score === n
                ? { background: 'var(--brand-primary)', borderColor: 'var(--brand-primary)', color: '#fff' }
                : { borderColor: '#e2e8f0' }
            }
          >
            {n}
          </button>
        ))}
      </div>
      {score !== null && (
        <>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={2}
            maxLength={500}
            placeholder="Un commentaire ? (facultatif)"
            className="rounded-lg border border-slate-200 p-2 text-sm focus:outline-none focus:ring-2"
            style={{ ['--tw-ring-color' as string]: 'var(--brand-primary)' }}
          />
          <button
            onClick={send}
            disabled={busy}
            className="rounded-xl py-2.5 text-sm font-semibold text-white disabled:opacity-40"
            style={{ background: 'var(--brand-primary)' }}
          >
            {busy ? 'Envoi…' : 'Envoyer mon avis'}
          </button>
        </>
      )}
    </div>
  );
}
